import { WEB_SOCKET_CONNECTION_STATUS } from "common/Constants";
import {
  get as _get,
  find as _find,
  upperCase as _upperCase,
  filter as _filter,
  includes,
  filter,
} from "lodash";
import { dateInDetail, isDateBetweenTwoDates } from "utils/Date";

export const getLoadingDataFirstTime = (store) =>
  _get(store, `common.loadingDataFirstTime`);
export const getUserName = (store) => _get(store, `common.userInfo.name`);
export const getClientid = (store) => _get(store, `common.clientid`);
export const getTrailPeriod = (store) => _get(store, `common.trailperiod`);
export const getCurrentPlan = (store) => _get(store, `common.currentplan`);
export const getUserInfo = (store) => _get(store, `common.userInfo`);
export const getUserRoleId = (store) =>
  _get(store, `common.userInfo.roleId`, "");
export const getUserRole = (store) =>
  _get(store, `common.userInfo.userRoleType`, "");
export const getToggleDrawer = (store) =>
  _get(store, `common.toggleDrawer`, "");
export const getIsUserLoggedIn = (store) =>
  _get(store, `common.isLoggedIn`, "");
export const getSelectedDepartmentId = (store) =>
  _get(store, `common.selectedDepartmentId`, []);
export const getDepartmentList = (store) =>
  _get(store, `common.departmentList`, []);
export const getAllDepartmentList = (store) =>
  _get(store, `common.allDepartmentList`, []);
export const getSubscriptionId = (store) =>
  _get(store, `common.subscriptionId`, "");
export const getSubscriptionStatus = (store) =>
  _get(store, `common.subscriptionStatus`, "");
export const getAccessibleEngagementIds = (store) => _get(store, `common.accessibleEngagementIds`);
export const getLoadingRoute = (store) => _get(store, `common.loadingRoute`);

export const getRoleList = (store) => _get(store, `common.roleList`, []);
export const getUserRoleList = (store) =>
  _get(store, `common.userRoleList`, []);
// export const getRoleName = (store) => _get(store, `common.roleName`, '');
export const getRoleName = (store) => {
  const roleid = _get(store, `common.userInfo.roleId`, "");
  return _get(
    _find(getRoleList(store), ({ roleId }) => {
      return roleid === roleId;
    }),
    "roleName",
    ""
  );
};
export const getDepartmentName = (store) => {
  // const departmentId = parseInt(_get(store, `common.selectedDepartmentId`, 0));
  const departmentId = getSelectedDepartmentId(store);
  const departmentList = getDepartmentList(store);
  const departmentNameList = [];
  departmentList.map((list) => {
    if (includes(departmentId, list.department_id)) {
      departmentNameList.push(list.department_name);
    }
  });
  return departmentNameList;
  // return _get(_find(getDepartmentList(store), ({department_id}) => {
  // return department_id === departmentId;
  // return includes(departmentId, department_id)
  // }), 'department_name', [])
};
export const getSysteDate = (store) => _get(store, `common.date`, "");

export const getTime = (store) => {
  const dateInfo = dateInDetail(getSysteDate(store));
  return _get(dateInfo, "time", "");
};

export const getTime24 = (store) => {
  const dateInfo = dateInDetail(getSysteDate(store));
  return _get(dateInfo, "time24", "");
};
export const getTimeZone = (store) => _get(store, `common.timeZone`);
export const getAfterMorningPrimeNoon = (store) =>
  _get(store, `common.afterMorningPrimeNoon`);
export const getActualSummaryData = (store) =>
  _get(store, `common.actualSummaryData`);

export const getAMPM = (store) => {
  const dateInfo = dateInDetail(getSysteDate(store));
  return _upperCase(_get(dateInfo, "meridiem", ""));
};

export const getLongDay = (store) => {
  const dateInfo = dateInDetail(getSysteDate(store));
  return `
        ${_get(dateInfo, "day", "")},
        ${_get(dateInfo, "monthName", "")} ${_get(dateInfo, "date", "")},
        ${_get(dateInfo, "year", "")}
    `;
};

export const getLocations = (store) => _get(store, `common.locationList`, []);

export const getBreakTypeList = (store) =>
  _get(store, `common.breakTypeList`, []);

export const getCheckInDateTime = (store) =>
  _get(store, `common.checkInDateTime`, "");

export const getCheckOutDateTime = (store) =>
  _get(store, `common.checkOutDateTime`, "");

export const getIsOnBreak = (store) => _get(store, `common.isOnBreak`, false);
export const getIsCheckedIn = (store) =>
  _get(store, `common.isCheckedIn`, false);
export const getCheckInLocationId = (store) =>
  _get(store, `common.checkInLocationId`, "");
export const getCheckInDepartmentId = (store) =>
  _get(store, `common.checkInDepartmentId`, "");

export const getToggleSuccessModal = (store) =>
  _get(store, `common.displaySuccessModal`, false);

export const getSuccessModalMessage = (store) =>
  _get(store, `common.successModalMessage`, false);

export const getUserList = (store) => _get(store, `common.userList`, []);
export const getCurrencyList = (store) => _get(store, `common.currencyList`, []);
export const getLiveConversionRate = (store) => _get(store, `common.liveConversionRate`, 1);

export const getNotificationList = (store) =>
  _get(store, `common.notificationList`, []);

export const getDepartmentUserList = (store) => {
  const departmentId = getSelectedDepartmentId(store);
  // return _filter(_get(store, `common.userList`, []), { 'department_id': departmentId });
  let output = _filter(_get(store, `common.userList`, []), (v) =>
    includes(departmentId, v.departmentid)
  );
  return output;
};

export const getToggleProcessingDrawer = (store) =>
  _get(store, `common.displayProcessingModal`, "");

export const getLeaveCategoryList = (store) =>
  _get(store, `common.leaveCategoryList`, []);

export const getHolidayList = (store) => _get(store, `common.holidayList`, []);

export const getHolidayListBetweenDates = (store, startDate, endDate) => {
  const holidayList = _get(store, `common.holidayList`, []);
  const holidays = filter(
    holidayList,
    ({ date }) => isDateBetweenTwoDates(date, startDate, endDate),
    {}
  );
  return holidays;
};

export const getStatusList = (store) => _get(store, `common.statusList`, []);

export const getBreakId = (store) => _get(store, `common.breakId`, []);

export const getPunchId = (store) => _get(store, `common.punchId`, "");

export const getWebSocketStatus = (store) =>
  _get(store, `common.webSocketStatus`, []);

export const getWebSocketStatusDisplay = (store) =>
  WEB_SOCKET_CONNECTION_STATUS[getWebSocketStatus(store)];

export const getChatMessageList = (store) =>
  _get(store, `common.chatMessageList`, []);

export const getUnreadChatMessageList = (store) =>
  _get(store, `common.newMessageIndicatorList`, []);

export const getChatMessageQueue = (store) =>
  _get(store, `common.chatMessageQueue`, []);

export const getChatSelectedStaffId = (store) =>
  _get(store, `common.chatSelectedStaffId`, []);

export const getShiftTimeMaster = (store, userid) => {
  const allShifts = _get(store, `common.shiftTimeMaster`, []);
  let userShifts = filter(allShifts, { user_id: userid });
  return userShifts.length > 0 ? userShifts : filter(allShifts, { user_id: 0 });
};

export const getStatusListFromID = (store, id) => {
  return _filter(_get(store, `common.statusList`, []), ({ status_id }) =>
    includes(id, status_id)
  );
};

export const getProfilePic = (store) => _get(store, `common.profilePic`, []);
export const getMenuList = (store) => _get(store, `common.menuList`, []);
export const getEditPerformanceContract = (store) =>
  _get(store, `common.editPerformanceContract`, []);
export const getActiveMenuList = (store) =>
  _get(store, `common.activeMenuList`);
export const getBandList = (store) => _get(store, `common.bandList`, []);
export const getUserMenuList = (store) =>
  _get(store, `common.userMenuList`, []);
export const getAIChatHistory = (store) =>
  _get(store, `common.aiChatHistory`, []);
export const getCurrentAIMessageDetails = (store) =>
  _get(store, `common.currentAIMessageDetails`, {});
export const getFormName = (store) => _get(store, `common.formName`);
export const getSupervisorList = (store) =>
  _get(store, `common.supervisorList`, []);
export const getlevelList = (store) => _get(store, `common.levelList`, []);
export const getCachedTimesheets = (store) =>
  _get(store, `common.cachedTimeSheets`);
export const getFilters = (store) => _get(store, `common.filters`);
export const getFilteredClientData = (store) =>
  _get(store, `common.filterClientData`);
export const getTempEngagementFormData = (store) =>
  _get(store, `common.tempengagementformdata`);
export const getEngagementSelectedTab = (store) =>
  _get(store, `common.engagementselectedtab`);
export const getEngagementMainTab = (store) =>
  _get(store, `common.engagementmaintab`);
export const getResourceData = (store) => _get(store, `common.resourceData`);
export const getallRoleList = (store) => _get(store, `common.allRoleList`, []);
export const getallLocationList = (store) =>
  _get(store, `common.allLocation`, []);
export const getallCompetencyList = (store) =>
  _get(store, `common.allCompetency`, []);
export const getallBreakList = (store) => _get(store, `common.allBreak`, []);
export const getallLeaveList = (store) => _get(store, `common.allLeave`, []);
export const getallShiftList = (store) => _get(store, `common.allShift`, []);
export const getallShiftCategoryList = (store) => {
  const value = _get(store, `common.allShiftCategory`, []);
  return Array.isArray(value) ? value : [];
};
export const getStatusCodes = (store) => _get(store, `common.statusCodes`, []);
export const getallHolidayList = (store) =>
  _get(store, `common.allHoliday`, []);
export const getCRMManagingOfficeList = (store) =>
  _get(store, `common.crmManagingOfficeList`, []);
export const getMinePerformanceList = (store) =>
  _get(store, `common.minePerformanceList`);
export const getMyTeamPerformanceList = (store) =>
  _get(store, `common.myteamPerformanceList`);
export const getLoadNewDataList = (store) =>
  _get(store, `common.loadNewDataList`);
export const getHigherOfficials = (store) =>
  _get(store, `common.higherOfficialsList`);
export const getChargeoutRatesList = (store) =>
  _get(store, `common.chargeoutRatesList`);

// Canonical BDO operating-country list, sourced from the insyts_countries table
// via master-data/userdetails (see App.js fetchMasterUserData -> setCountryList).
export const getCountryList = (store) => _get(store, `common.countryList`, []);

// Billing entity master list, sourced from the billing_entity_master table
// via master-data/userdetails (see App.js fetchMasterUserData -> setBillingEntityList).
export const getBillingEntityList = (store) => _get(store, `common.billingEntityList`, []);

// Per-tenant branding config (company_name, domain_url, powerbi_url,
// support_email, logo_url), sourced from company_profile_master
// via master-data/userdetails (see App.js fetchMasterUserData -> setCompanyProfile).
export const getCompanyProfile = (store) => _get(store, `common.companyProfile`, {});

// Client-configured job grades ({id, jobgradecode, jobgrade, designation}, ordered
// by id), sourced from insytsConfigurationData via master-data/userdetails
// (see App.js fetchMasterUserData -> setGradeList). Replaces the old hardcoded
// Grade list in common/Constants.js.
export const getGradeList = (store) => _get(store, `common.gradeList`, []);

// Whether the logged-in user's managing office runs on Insyts CRM, per that
// country's country_rule.crm flag (see backend getCountries()). Client lists
// for Insyts CRM offices come from the CRM clients endpoint instead of the
// regular clients endpoint (see getAllownClientsList in common/queryKey).
export const getIsInsytsCrmManagingOffice = (store) => {
  const managingOffice = _get(store, `common.userInfo.managingoffice[0]`);
  const country = getCountryList(store).find(
    (c) => c.countryname === managingOffice
  );
  return _get(country, "country_rule.crmType") === "Insyts CRM";
};

// Whether the logged-in user's managing office can access organization charts.
export const getCanViewOrganizationCharts = (store) => {
  const managingOffice = _get(store, `common.userInfo.managingoffice[0]`);
  const country = getCountryList(store).find(
    (c) => c.countryname === managingOffice
  );
  return _get(country, "country_rule.orgChart") === "Yes";
};

// Whether the logged-in user's managing office uses the Custom (file-upload)
// Job Description flow in Appraisal Information instead of the grade-based
// one, per country_rule.performancejobdescription ("Custom" vs
// "Settings Menu").
export const getIsCustomPerformanceJobDescription = (store) => {
  const managingOffice = _get(store, `common.userInfo.managingoffice[0]`);
  const country = getCountryList(store).find(
    (c) => c.countryname === managingOffice
  );
  return _get(country, "country_rule.performancejobdescription") === "Custom";
};

export const getCountryCodeOptions = (store) =>
  getCountryList(store).map((c) => ({
    code: c.countrycode,
    country: c.countryname,
  }));

export const getCountryCompanyList = (store) =>
  getCountryList(store).map((c) => ({
    country: c.countryname,
    location: c.countrytimezone
      ? c.countrytimezone.split("/")[1]?.replace(/_/g, " ")
      : "",
  }));

export const getCountryTimezoneList = (store) =>
  getCountryList(store).map((c) => ({
    country: c.countryname,
    Timezone: c.countrytimezone,
  }));

export const getCountryFilterResourcePlanningList = (store) =>
  getCountryList(store).map((c) => ({ country: c.countryname }));

// Head Office has no chargeout-rate column of its own in the chargeout-rates
// dataset; the code it should fall back to is a rate-lookup business rule, not
// country reference data, so it isn't sourced from insyts_countries.
export const getCountryNameToCodeMap = (store, headOfficeFallbackCode = "standard") =>
  getCountryList(store).reduce((acc, c) => {
    acc[c.countryname] =
      c.countryname === "Head Office" ? headOfficeFallbackCode : c.countrycode;
    return acc;
  }, {});
export const getMyTeamPerformanceResponseViewList = (store) =>
  _get(store, `common.myteamPerformanceResponseViewList`);

export const getManagingOffice = (store, userid) => {
  const manageoffice = _get(store, `common.levelList`, []);
  let level1_values = [];
  manageoffice.forEach((level) => {
    switch (level.levelName) {
      case "Level1":
        level.value.forEach((value) => {
          value.value.forEach((item) => {
            level1_values.push(item);
          });
        });
        break;
      default:
        break;
    }
  });
  return level1_values;
};

export const getCompetencyQc = (store, userid) => {
  const data = _get(store, `common.levelList`, []);
  let level1_values = [];
  data.forEach((level) => {
    switch (level.levelName) {
      case "Level2":
        level.value.forEach((value) => {
          value.value.forEach((item) => {
            level1_values.push(item);
          });
        });
        break;
      default:
        break;
    }
  });
  return level1_values;
};
export const getServiceLine = (store, userid) => {
  const data = _get(store, `common.levelList`, []);
  let level1_values = [];
  data.forEach((level) => {
    switch (level.levelName) {
      case "Level3":
        level.value.forEach((value) => {
          value.value.forEach((item) => {
            level1_values.push(item);
          });
        });
        break;
      default:
        break;
    }
  });
  return level1_values;
};
